module.exports = __webpack_public_path__ + "img/suggestion-active.51d88d26.svg";